import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { AppSettingService, RolesService } from '../../../../api/services'
import { validateAllFormFields } from '../../../../formUtils'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { CarefinityRoles } from '../../../../api/models/carefinity-roles'

@Component({
  selector: 'app-manageroles',
  templateUrl: './manageroles.component.html',
  styleUrls: ['./manageroles.component.css'],
})
export class ManagerolesComponent implements OnInit {
    role: CarefinityRoles
  privelleges: any[]
  RoleId: number
  description: string
  practiceId: string
  RolesForm
  IsCheckedAll: boolean = false

  showAppointment: boolean = false
  showSignOffQueue: boolean = false
  showTasks: boolean = false
  showReports: boolean = false
  showpatientArchive: boolean = false
  enableEmergencyToken: boolean = false
  showPatientImage: boolean = false
  showPatientDocuments: boolean = false
  showExportDocuments: boolean = false
  showPatientNotes: boolean = false
  enableBilling: boolean = false
  showFinancialSummary: boolean = false
  showRestoreTabToUser: boolean = false
  showFinancialData: boolean = false
  showSensitiveData: boolean = false
    showClinicalData: boolean = false;


    showPatientDemographics: boolean = false;
    showPatientPayer: boolean = false;

    isGlobalAdmin = false;

    isglobalAdminPrivilegedependentItems: boolean = false;
    //Print Patient Data
    showPatientDemographicPrint: boolean = false;

    showSignificantEvent: boolean = false;
    title: string = 'Manage Role - Add';
    isGlobalPrivileges: boolean = false;
    enableDocumentDownloads: boolean
  constructor(
    private messageService: MessageService,
    private _appService: AppSettingService,
    private _roleService: RolesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      let data = params
      this.RoleId = data.role_Id
    })
    this.practiceId = localStorage.getItem('PracticeId')

    this.setRolesForm(false)

    this.showHidePrevelegesBasedOnSettings()
      if (this.RoleId == -1)
      {
          this.title = 'Create Role';


          this.RolesForm.get('securityQuestions')?.disable();
          this.RolesForm.get('resetAllPasswords')?.disable();
          this.RolesForm.get('manageGlobalConfig')?.disable();
      }
      else {
          this.title = 'Update Role';

        this.loadGeneralRoles()
      }

      // Subscribe to value changes for specific controls to ensure numeric values
     this.addValueChangeSubscriptions();

  }
    // Adding subscriptions to specific controls
     addValueChangeSubscriptions(): void {
        this.RolesForm
            .get('globalAdminPrivilege')
            ?.valueChanges.subscribe((res) => {
                if (res == true) {
                   
                    this.RolesForm.get('securityQuestions')?.setValue(res);
                    this.RolesForm.get('resetAllPasswords')?.setValue(res);
                    this.RolesForm.get('manageGlobalConfig')?.setValue(res);

                    this.RolesForm.get('securityQuestions')?.enable();
                    this.RolesForm.get('resetAllPasswords')?.enable();
                    this.RolesForm.get('manageGlobalConfig')?.enable();
                }
                else
                {
                    
                    this.isglobalAdminPrivilegedependentItems = true;
                    this.RolesForm.get('securityQuestions')?.setValue(res);
                    this.RolesForm.get('resetAllPasswords')?.setValue(res);
                    this.RolesForm.get('manageGlobalConfig')?.setValue(res);

                    this.RolesForm.get('securityQuestions')?.disable();
                    this.RolesForm.get('resetAllPasswords')?.disable();
                    this.RolesForm.get('manageGlobalConfig')?.disable();

                   
                }
               
                  
            })
    }

  setRolesForm(Check: boolean) {
    this.RolesForm = this.fb.group({
      roleName: new UntypedFormControl(null, [Validators.required]),
      roleDescription: new UntypedFormControl(null, []),
      appointment: new UntypedFormControl(Check, []),
      patientSearch: new UntypedFormControl(Check, []),
      //signOffQueue: new UntypedFormControl(Check, []),
      //tasks: new UntypedFormControl(Check, []),
      changePassword: new UntypedFormControl(Check, []),
      viewReports: new UntypedFormControl(Check, []),
      viewPatientReports: new UntypedFormControl(Check, []),
      manageReports: new UntypedFormControl(Check, []),
      manageNotes: new UntypedFormControl(Check, []),
      manageUsers: new UntypedFormControl(Check, []),
      manageRoles: new UntypedFormControl(Check, []),
      resetAllPasswords: new UntypedFormControl(Check, []),
      patientArchive: new UntypedFormControl(Check, []),
      securityQuestions: new UntypedFormControl(Check, []),
      emergencyToken: new UntypedFormControl(Check, []),
      manageUserPractices: new UntypedFormControl(Check, []),
      patientDemographics: new UntypedFormControl(Check, []),
      dashboard: new UntypedFormControl(Check, []),
      allergies: new UntypedFormControl(Check, []),
      problems: new UntypedFormControl(Check, []),
      visits: new UntypedFormControl(Check, []),
      images: new UntypedFormControl(Check, []),
      documents: new UntypedFormControl(Check, []),
      labs: new UntypedFormControl(Check, []),
      orders: new UntypedFormControl(Check, []),
      vitals: new UntypedFormControl(Check, []),
      exportdocuments: new UntypedFormControl(Check, []),
      charge: new UntypedFormControl(Check, []),
      financialSummary: new UntypedFormControl(Check, []),
      significantEvents: new UntypedFormControl(Check, []),
      medication: new UntypedFormControl(Check, []),
      notes: new UntypedFormControl(Check, []),
      showSensitiveData: new UntypedFormControl(Check, []),
      checkAll: new UntypedFormControl(Check, []),
      showRestoreTabToUser: new UntypedFormControl(Check, []),
      managePracticeConfig: new UntypedFormControl(Check, []),
      manageGlobalConfig: new UntypedFormControl(Check, []),
      globalAdminPrivilege: new UntypedFormControl(Check, []),
      manageGlobalSetting: new UntypedFormControl(Check, []),
      patientRecordsPrint: new UntypedFormControl(Check, []),
        enableDocumentDownloads: new UntypedFormControl(Check, []),
      managePatientDemographic: new UntypedFormControl(Check, []),
      managePatientPayer: new UntypedFormControl(Check, [])
    })
  }
  showHidePrevelegesBasedOnSettings() {
    this.showAppointment = CareFinitySession.practiceSettings.showAppointment
    this.showSignOffQueue = CareFinitySession.practiceSettings.showSignOffQueue
    this.showTasks = CareFinitySession.practiceSettings.showTasks
    this.showReports = CareFinitySession.applicationSettings.applicationFeatures.showReports
    this.showpatientArchive =CareFinitySession.practiceSettings.showPatientArchive
    this.enableEmergencyToken =CareFinitySession.applicationSettings.isEmergencyTokenEnabled
      this.showPatientImage = CareFinitySession.practiceSettings.showPatientImage

      this.showPatientDocuments = //CareFinitySession.applicationSettings.applicationFeatures.showPatientDocuments
          CareFinitySession.practiceSettings.showPatientDocuments;
    this.showExportDocuments = CareFinitySession.practiceSettings.showExportDocuments
    this.showPatientNotes = CareFinitySession.practiceSettings.showPatientNotes
    this.enableBilling = CareFinitySession.practiceSettings.enableBilling
    this.showFinancialSummary = CareFinitySession.practiceSettings.enableFinancialSummary
    this.showRestoreTabToUser =  CareFinitySession.practiceSettings.showRestoreTabToUser
       this.showSensitiveData = CareFinitySession.practiceSettings.showSensitiveData
    //  this.showSensitiveData=CareFinitySession.applicationSettings.showSensitiveData
      this.isGlobalAdmin = CareFinitySession.user.roles.globalAdminPrivilege;
      this.showPatientDemographicPrint = CareFinitySession.practiceSettings.enablePatientDemographicPrint;
      this.enableDocumentDownloads = CareFinitySession.practiceSettings.enableDocumentDownloads;

      this.showSignificantEvent = CareFinitySession.practiceSettings.isSignificantEvent;

      this.showPatientDemographics = CareFinitySession.practiceSettings.showPatientDemographics;
      this.showPatientPayer = CareFinitySession.practiceSettings.showPatientPayer;

  }
    loadGeneralRoles() {
        this._roleService
            .rolesGetCarefinityRoles({
                PracticeId: this.practiceId,
                roleId: this.RoleId,
            })
            .subscribe((data) => {
                console.log(data);
                this.role = CareFinitySession.user.roles;
             this.isGlobalPrivileges= this.isGlobalAdmin || this.role?.globalAdminPrivilege || this.role?.manageGlobalConfig || this.role?.securityQuestions;
                
        this.RolesForm.patchValue(data)
      })
    }

    checkUncheckAll() {
        const val = this.RolesForm.controls['checkAll'].value;
        this.role = CareFinitySession.user.roles;
        const hasGlobalPrivileges = this.isGlobalAdmin || this.role?.globalAdminPrivilege || this.role?.manageGlobalConfig || this.role?.securityQuestions;
        this.patchRolesForm(val, hasGlobalPrivileges);
    }
    patchRolesForm(Check: boolean, isGlobal: boolean) {
        const roleSettings = {
            appointment: Check,
            patientSearch: Check,
            changePassword: Check,
            viewReports: Check,
            viewPatientReports: Check,
            manageReports: Check,
            manageNotes: Check,
            manageRoles: Check,
            manageUsers: Check,
            resetAllPasswords: isGlobal ? Check : false,
            patientArchive: Check,
            securityQuestions: isGlobal ? Check : false,
            emergencyToken: Check,
            manageUserPractices: Check,
            patientDemographics: Check,
            dashboard: Check,
            allergies: Check,
            problems: Check,
            visits: Check,
            images: Check,
            documents: Check,
            labs: Check,
            orders: Check,
            vitals: Check,
            exportdocuments: Check,
            charge: Check,
            financialSummary: Check,
            significantEvents: Check,
            medication: Check,
            notes: Check,
            showSensitiveData:  isGlobal? Check: false,
            showRestoreTabToUser: Check,
            managePracticeConfig: Check,
            manageGlobalConfig: isGlobal ? Check : false,
            globalAdminPrivilege: isGlobal ? Check : false,
            manageGlobalSetting: Check,
            patientRecordsPrint: Check,
            enableDocumentDownloads: Check,
            managePatientDemographic : Check,
            managePatientPayer: Check
        };

        this.RolesForm.patchValue(roleSettings);
    }



  save() {
    validateAllFormFields(this.RolesForm)

    if (this.RolesForm.invalid) {
      return
    }

    if (this.RoleId == -1) {
      this._roleService
        .rolesCreateRoles({
          body: this.RolesForm.value,
        })
        .subscribe(
          (result) => {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: 'Roles Added successfully',
              summary: 'Confirmation',
              life: 5000,
            })
            this.router.navigate(['administration/manage-roles'])
          },
          (error) => {
            this.messageService.add({
              key: 'alertToast',
                severity: 'error',
                detail: `This role name is already taken.Please choose another role name.!`,
              summary: 'ERROR',
              life: 5000,
            })
          },
        )
    } else {
      this._roleService
        .rolesEditRoles({
          RoleId: this.RoleId,
          body: this.RolesForm.value,
        })
        .subscribe(
          (result) => {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: 'Roles Updated successfully',
              summary: 'Confirmation',
              life: 5000,
            })
            this.router.navigate(['administration/manage-roles'])
          },
          (error) => {
            this.messageService.add({
              key: 'alertToast',
                severity: 'error',
                detail: `This role name is already taken.Please choose another role name.!`,
                summary: 'ERROR',
              life: 5000,
            })
          },
        )
    }
  }
}
